export default __webpack_public_path__ + "static/media/news2.5de1352b.png";